var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuitcaseOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.993,
    height: 32,
    viewBox: "0 0 27.993 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "suitcase_outline",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118002",
    "data-name": "Path 118002",
    d: "M45,43.412V39.882m0,3.529v3.529m0-3.529h9.747a3.4,3.4,0,0,0,3.249-3.529M45,43.412H35.249A3.4,3.4,0,0,1,32,39.882m25.993,0V50.471A3.4,3.4,0,0,1,54.744,54H35.249A3.4,3.4,0,0,1,32,50.471V39.882m25.993,0V32.824a3.4,3.4,0,0,0-3.249-3.529H35.249A3.4,3.4,0,0,0,32,32.824v7.059M49.87,29.294V27.529A3.4,3.4,0,0,0,46.621,24H43.372a3.4,3.4,0,0,0-3.249,3.529v1.765",
    transform: "translate(-32 -24)",
    fill: "none",
    stroke: "#959595",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcaseOutline);
export default __webpack_public_path__ + "static/media/suitcase_outline.e1c4755fecae1a712f79b11acd02eb24.svg";
export { ForwardRef as ReactComponent };